module.exports = __webpack_public_path__ + "img/portovelho-ico-agendamento-sucesso.6119b6bc.png";